import React from "react";

const ExpenseDetailInfo = (props) => {
  const { expense } = props;
  return (
    <div className="row mb-5 expense-info-wrap">
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success">
            <i className="text-success fas fa-user"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Seller</h6>
            <p className="mb-1">
              {expense.user.name} <br />
              <a href={`mailto:${expense.user.email}`}>{expense.user.email}</a>
            </p>
          </div>
        </article>
      </div>
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success">
            <i className="text-success fas fa-file-alt"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Expense Title</h6>
            <p className="mb-1">
              {expense.expenseTitle}
            </p>
          </div>
        </article>
      </div>
      <div className="col-md-6 col-lg-4">
        <article className="icontext align-items-start">
          <span className="icon icon-sm rounded-circle alert-success">
            <i className="text-success fas fa-comment"></i>
          </span>
          <div className="text">
            <h6 className="mb-1">Expense Description</h6>
            <p className="mb-1">
                {expense.expenseDescription}
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default ExpenseDetailInfo;
